import { render, staticRenderFns } from "./childDetail.vue?vue&type=template&id=2a91d348&scoped=true&"
import script from "./childDetail.vue?vue&type=script&lang=js&"
export * from "./childDetail.vue?vue&type=script&lang=js&"
import style0 from "./childDetail.vue?vue&type=style&index=0&id=2a91d348&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a91d348",
  null
  
)

export default component.exports